import Box from '@mui/material/Box';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import React, { Fragment, useState, useEffect } from 'react';
import estilos from './ToolBarPaginas.module.css'
function TabLista({ value, handleChange, data }) {

  

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      textAlign: 'center', backgroundColor: '#fcfcfc', width: '86%',
      boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)', height: '60px', borderRadius: '8px',
      position: 'fixed', zIndex: 999, left: '50%', marginLeft: '-43%'
    }} /*className={`${stickyClass}`}*/>

      <TabList onChange={handleChange} aria-label="visible arrows tabs example" variant="scrollable" scrollButtons="auto" className='text-center'
        TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
        sx={{
          "& button": { color: '#7D9A47', fontFamily: 'Montserrat', fontWeight: 'bold' },
          "& button:hover": { color: '#7D9A47', transform: 'scale(1.1)' },
          "& button.Mui-selected": { backgroundColor: '#7D9A47', color: 'white', borderTopLeftRadius: 9, borderTopRightRadius: 9, borderBottomLeftRadius: 9, borderBottomRightRadius: 9 }
        }}>

        <Tab label="Datos Generales" value="datosGenerales" />
        <Tab label="Instalaciones" value="Instalaciones" />
        <Tab label="Marcas" value="marcas" />
        <Tab label="Documentacion" value="documentacion" />

      </TabList>
    </Box>
  );
}

export default TabLista;
